import React, { useState, useEffect } from 'react'
import { Trans } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import BuildingAnalyticIcons from '../BuildingAnalytics/BuildingAnalyticIcons/BuildingAnalyticIcons'
import { BOOKING_TYPES_ICONS } from '../../helpers/constants'
import { colors } from '../BuildingAnalytics/AnalyticsConstants'
import {
  selectBookCategories,
  fetchAllBookingCategories,
} from '../../reducers/Organisation/bookCategoryReducer'
import { fetchSingleBuilding } from '../../reducers/buildingSelectorReducer'
import {
  fetchAllBookingTypes,
  selectBookTypesByCategory,
  sortByOrder,
} from '../../reducers/Organisation/bookTypesReducer'
import { fetchServicesQuestions, selectQuestions } from '../../reducers/serviceFormReducer'
import { ABILITIES } from '../../components/Can'
import { getCookie } from '../../helpers/helpers'
import { selectUserData } from '../../reducers/userDataReducer'

import BookingSidebar from './BookingSidebar'

const SUPPORT_EMAIL = 'Hello@elevatedliving.com'

const Booking = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const bookingCategories = useSelector(selectBookCategories) || []
  const bookingTypes = useSelector(selectBookTypesByCategory) || {}
  const questions = useSelector(selectQuestions) || []
  const userData = useSelector(selectUserData)

  const [selectedServiceId, setSelectedServiceId] = useState(null)
  const [selectedCategoryId, setSelectedCategoryId] = useState(null)
  const [visibleSuccessPopup, setVisibleSuccessPopup] = useState(false)

  useEffect(() => {
    if (
      !ABILITIES.Navbar.booking.includes(userData?.user?.role) ||
      (userData?.buildingId && !userData?.buildingId?.servicesAvailable)
    ) {
      navigate('/')
    }
  }, [userData, navigate])

  useEffect(() => {
    dispatch(fetchAllBookingCategories()).catch(() => {})
    dispatch(fetchAllBookingTypes()).catch(() => {})
    dispatch(fetchSingleBuilding(userData?.buildingId?.id)).catch(() => {})
    dispatch(fetchServicesQuestions()).catch(() => {})
  }, [dispatch, userData])

  const selectServiceOption = ({ categoryId, serviceId, link }) => {
    if (link) {
      let finalLink = link
      const token = getCookie('token')
      if (link.includes('{token}') && token) {
        finalLink = link.replace(/{token}/i, token)
      }
      window.open(finalLink, '_blank')
    } else {
      setSelectedServiceId(serviceId)
      setSelectedCategoryId(categoryId)
    }
  }

  const closeSidebar = () => {
    setSelectedServiceId(null)
    setSelectedCategoryId(null)
    setVisibleSuccessPopup(true)
    setTimeout(() => setVisibleSuccessPopup(false), 3000)
  }

  return (
    <div className="booking-container">
      <div className={`booking-success-message-popup ${visibleSuccessPopup ? 'is-visible' : ''}`}>
        <Trans
          components={[<a href={`mailto:${SUPPORT_EMAIL}`} />]}
          i18nKey="booking:requestSubmitted"
          values={{ email: SUPPORT_EMAIL }}
        />
      </div>
      <div className="booking-services-section">
        {bookingCategories &&
          sortByOrder(bookingCategories).map(({ id, name }) => {
            if (bookingTypes[id]?.length) {
              return (
                <React.Fragment key={id}>
                  <div className="category-header">
                    <h3>{name}</h3>
                    <div />
                  </div>
                  <div className="booking-services-category-container">
                    {sortByOrder(bookingTypes[id]).map((bookingType) => (
                      <div
                        key={bookingType.id}
                        className={`service-container ${
                          selectedServiceId === bookingType.id ? 'focused' : ''
                        }`}
                        onClick={() =>
                          selectServiceOption({
                            categoryId: id,
                            serviceId: bookingType.id,
                            link: bookingType.link,
                          })
                        }
                      >
                        <div
                          className="modal__icon"
                          style={{
                            backgroundColor: colors[bookingType.icon],
                            color: 'white',
                          }}
                        >
                          <BuildingAnalyticIcons
                            name={BOOKING_TYPES_ICONS.find((icon) => icon === bookingType.icon)}
                          />
                        </div>
                        {bookingType.name}
                      </div>
                    ))}
                  </div>
                </React.Fragment>
              )
            }
          })}
      </div>
      {selectedServiceId && (
        <BookingSidebar
          serviceBody={bookingTypes[selectedCategoryId]?.find(
            (service) => service.id === selectedServiceId,
          )}
          servicesFaqLink={userData?.buildingId?.servicesFaqLink}
          closeSidebar={closeSidebar}
          serviceQuestions={questions.filter(
            (question) =>
              question.bookingTypeId?.id ===
              bookingTypes[selectedCategoryId]?.find((service) => service.id === selectedServiceId)
                ?.id,
          )}
        />
      )}
    </div>
  )
}

export default Booking
